<template>
    <div class="BlockPage">
        <b-list-group>
            <!--<b-list-group-item v-for="t in tenants" class="text-left hover-style">-->
            <b-table
                    class="t-style"
                    hover
                    :items="tenantsProp"
                    primary-key="id"
            >
                <template #cell(Tenant)="row">
                    <div class="text-left">{{ row.value }}</div>
                </template>
                <template #cell(Balance)="row">
                    <div class="text-right">{{ row.value }}</div>
                </template>
                <template #cell(Deposit)="row">
                    <div class="text-right">{{ row.value }}</div>
                </template>
                <template #cell(Notes)="row">
                    <b-button size="sm" @click="showNotes(row.value)" class="mr-1">
                        View Notes
                    </b-button>
                </template>

            </b-table>
        </b-list-group>
    </div>
</template>

<script>
    import numeral from 'numeral';

    export default {
        created() {
            this.tenantsProp = [];
            let n = 0;
            for (let row of this.tenants) {
                this.tenantsProp.push({
                        "No": row.TenantAccNo,
                        "Tenant": row.Initial + " " + row.Surname,
                        "Monthly Rent": "R " + numeral(row.Rental).format('0,0.00'),
                        "Deposit": "R " + numeral(row.DepositBalance).format('0,0.00'),
                        "Balance": "R " + numeral(row.Balance).format('0,0.00'),
                        "Notes" : n
                    }
                );
                this.tenantsNotes['no'+n] = row.Notes;
                n++;
            }
        },
        methods: {
            showNotes(n) {
                this.$emit('showModal',this.tenantsNotes['no'+n]);
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            }
        },
        data() {
            return {
                fields: [{
                    key: "No"
                }, {
                    key:"Tenant"
                }, {
                    key: "Monthly Rent"
                }, {
                    key: "Balance"
                }, {
                    key: "Deposit"
                }, {
                    key: "Notes"
                }],
                tenantsProp: [],
                tenantsNotes: {}
            }
        },
        props: {
            building: String,
            tenants: Array
        },
    };
</script>
<style>
    .t-style td {
        cursor: pointer;
    }

    .hover-style:hover {
        background-color: rgba(83, 93, 217, 0.42);
        cursor: pointer;
    }
</style>
